import { BaseExtension } from '../registry/extension';
/**
 * <zh/> 数据转换的基类
 *
 * <en/> Base class for data transforms
 */
export class BaseTransform extends BaseExtension {
    beforeDraw(data, context) {
        return data;
    }
    afterLayout(type, data) { }
}
//# sourceMappingURL=base-transform.js.map